import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {Button, SectionCard} from '@livingdata/playground-core-front'

import {useCharterReading} from '../hooks/use-charter-reading'

export function CharterNotice() {
  const {t} = useTranslation()
  const hasRead = useCharterReading()

  return (
    <SectionCard
      layout='inline'
      title={t('charter.notice.title')}
      description={t('charter.notice.description')}
      action={
        // The charter stays reachable whatever the state, so only the invitation
        // varies: a quieter button, and a label that stops asking for a reading
        // already recorded.
        <Button isAsChild variant={hasRead ? 'outline' : 'default'}>
          <Link to='/charte'>{t(hasRead ? 'charter.notice.access' : 'charter.notice.action')}</Link>
        </Button>
      }
    />
  )
}
